import { render } from "./FormBox.vue?vue&type=template&id=73cd2826&scoped=true"
import script from "./FormBox.vue?vue&type=script&lang=js"
export * from "./FormBox.vue?vue&type=script&lang=js"

import "./FormBox.vue?vue&type=style&index=0&id=73cd2826&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73cd2826"]])

export default __exports__